import { StudyItemData } from '../study_items/types';

export interface StudyScheduleStore {
  currentStudySchedule: StudyScheduleDetailData;
  studySchedules: StudyScheduleData[];
  showExamSectionFocusStep: boolean;
  ui: {
    presentPlanOptions?: boolean;
  };
  userProfile: {
    examName?: string;
    studyExperience?: string;
    testDate?: string;
    examSectionFocus?: ExamSectionFocus;
  };
}

export interface StudyScheduleData {
  accessLevel: number;
  experienceLevels: string;
  id: number;
  minDaysUntilTest: number;
  name: string;
  examSectionFocus: ExamSectionFocus;
}

export interface StudyScheduleDetailData {
  currentDay: StudyScheduleDayDetailData;
  days: StudyScheduleDayData[];
  id: number;
  name: string;
  learningSessionsPerSet: number;
  learningSessionSetName: string;
  learningSessionName: string;
}

export interface StudyScheduleDayData {
  id: number;
  name: string;
}

export interface StudyScheduleDayDetailData {
  id: number;
  items: StudyItemData[];
  name: string;
}

export interface PracticePreviewData {
  exam: string;
  includeOldPrompts: boolean;
  minutes: number;
  questionCount: number;
  questionType: string;
  examSection?: string;
  quizMode: boolean;
  blockId: number;
}

export enum ExamSectionFocus {
  MathAndVerbal = 'math_and_verbal',
  Math = 'math',
  Verbal = 'verbal'
}
